import React, { useEffect, useState } from 'react';
import {
  CommandDialog,
  CommandInput,
  CommandList,
  CommandEmpty,
  CommandGroup,
  CommandItem,
} from '@/components/ui/command';
import { BookOpen, HelpCircle, Clock, Bookmark } from 'lucide-react';

export function SearchDialog({ isOpen, onClose, sections, bookmarks, onSelect }) {
  const [query, setQuery] = useState('');

  useEffect(() => {
    if (!isOpen) setQuery('');
  }, [isOpen]);

  // Keyboard shortcut is handled in App.js

  const bookmarkedSections = sections.filter(s => bookmarks.includes(s.id));

  return (
    <CommandDialog open={isOpen} onOpenChange={(open) => { if (!open) onClose(); }}>
      <CommandInput
        data-testid="search-input"
        placeholder="Search topics, subtopics, modules..."
        value={query}
        onValueChange={setQuery}
      />
      <CommandList>
        <CommandEmpty>No results found.</CommandEmpty>

        {bookmarkedSections.length > 0 && !query && (
          <CommandGroup heading="Bookmarked">
            {bookmarkedSections.map(s => (
              <CommandItem
                key={`bm-${s.id}`}
                data-testid={`search-result-${s.id}`}
                onSelect={() => { onSelect(s.id); onClose(); }}
                className="flex items-center gap-2 cursor-pointer"
              >
                <Bookmark className="h-4 w-4 text-blue-500 shrink-0" />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium truncate">{s.title}</p>
                  {s.moduleName && (
                    <p className="text-xs text-muted-foreground truncate">{s.moduleName}</p>
                  )}
                </div>
                {s.readingTime && (
                  <span className="text-xs text-muted-foreground flex items-center gap-0.5 shrink-0">
                    <Clock className="h-3 w-3" />{s.readingTime}m
                  </span>
                )}
              </CommandItem>
            ))}
          </CommandGroup>
        )}

        <CommandGroup heading="All Topics">
          {sections.map(s => (
            <CommandItem
              key={s.id}
              data-testid={`search-result-${s.id}`}
              onSelect={() => { onSelect(s.id); onClose(); }}
              className="flex items-center gap-2 cursor-pointer"
              value={`${s.title} ${s.moduleName || ''} ${s.topicName || ''}`}
            >
              {s.type === 'quiz' ? (
                <HelpCircle className="h-4 w-4 text-amber-500 shrink-0" />
              ) : (
                <BookOpen className="h-4 w-4 text-zinc-400 shrink-0" />
              )}
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium truncate">{s.title}</p>
                {s.moduleName && (
                  <p className="text-xs text-muted-foreground truncate">
                    {s.moduleName}{s.topicName ? ` > ${s.topicName}` : ''}
                  </p>
                )}
              </div>
              {s.readingTime && (
                <span className="text-xs text-muted-foreground flex items-center gap-0.5 shrink-0">
                  <Clock className="h-3 w-3" />{s.readingTime}m
                </span>
              )}
            </CommandItem>
          ))}
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}
